import { render, staticRenderFns } from "./ImpedimentosMultiples.vue?vue&type=template&id=76365dd2&scoped=true"
import script from "./ImpedimentosMultiples.vue?vue&type=script&lang=js"
export * from "./ImpedimentosMultiples.vue?vue&type=script&lang=js"
import style0 from "./ImpedimentosMultiples.vue?vue&type=style&index=0&id=76365dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76365dd2",
  null
  
)

export default component.exports